<template>
  <div class="deploy-setting">
    <div class="type-def-wrap">
      <div class="method-wrap type-def">
        <div class="labels">部署方式</div>
        <el-radio-group v-model="deployMethod">
          <el-radio :label="0">单机部署</el-radio>
          <el-radio :label="1">多机部署</el-radio>
        </el-radio-group>
      </div>
      <div v-if="enableContractSql" class="contract-sql-wrap type-def">
        <div class="labels">
          <span>SQL合约</span>
        </div>
        <el-radio-group v-model="supportContractSql">
          <el-radio :label="1">支持</el-radio>
          <el-radio :label="0">不支持</el-radio>
        </el-radio-group>
      </div>
    </div>
    <el-alert
      v-if="supportContractSql && enableContractSql"
      title="每个节点需有相应的部署好的MySql，各个MySql相互独立，且设置的用户需具有 create database / table 的权限"
      type="default"
      show-icon
      :closable="false"
      class="type-def-alert"
    >
    </el-alert>
    <div class="input-wrap">
      <div class="input-header">
        <div class="node-header header-section merge">
          <div class="header-line">
            <span class="cell">节点编号</span>
          </div>
        </div>
        <div class="deploy-header header-section">
          <div class="header-line">
            <span class="cell">服务器信息</span>
          </div>
          <div class="header-line">
            <span class="cell">IP地址</span>
            <span class="cell narrow">RPC端口</span>
            <span class="cell narrow">P2P端口</span>
          </div>
        </div>
        <div
          v-if="supportContractSql && enableContractSql"
          class="contract-sql-header header-section"
        >
          <div class="header-line">
            <span class="cell">MySql信息</span>
          </div>
          <div class="header-line">
            <span class="cell">用户名称</span>
            <span class="cell">密码</span>
            <span class="cell">Host/IP</span>
            <span class="cell narrow">端口</span>
          </div>
        </div>
      </div>
      <div v-for="(item, i) in nodeList" :key="item.NodeName + i" class="input-item">
        <div class="labels node" :title="item.NodeName">
          <span>{{ item.NodeName }}</span>
        </div>
        <el-form
          ref="deploySetting"
          :inline="true"
          :model="item"
          :rules="editRules"
          class="input-form-inline"
        >
          <el-form-item label="" prop="NodeIp">
            <el-input v-model="item.NodeIp" :placeholder="deployMethod === 0 && i > 0 ? '同上' : 'IP地址'"
              :disabled="deployMethod === 0 && i > 0" class="node-input"></el-input>
          </el-form-item>
          <el-divider direction="vertical"></el-divider>
          <el-form-item label="" prop="NodeRpcPort">
            <el-input
              v-model.number="item.NodeRpcPort"
              placeholder="RPC端口"
              class="node-input narrow"
            ></el-input>
          </el-form-item>
          <el-divider direction="vertical"></el-divider>
          <el-form-item label="" prop="NodeP2pPort">
            <el-input
              v-model.number="item.NodeP2pPort"
              placeholder="P2P端口"
              class="node-input narrow"
            ></el-input>
          </el-form-item>
          <el-divider direction="vertical"></el-divider>
        </el-form>
        <el-form
          v-if="supportContractSql && enableContractSql"
          ref="contractSqlSetting"
          :inline="true"
          :model="item"
          :rules="contractSqlEditRules"
          class="input-form-inline"
        >
          <el-form-item label="" prop="sqlUserName">
            <el-input v-model="item.sqlUserName" placeholder="请输入" class="node-input"></el-input>
          </el-form-item>
          <el-divider direction="vertical"></el-divider>
          <el-form-item label="" prop="sqlPassword">
            <el-input v-model="item.sqlPassword" placeholder="请输入" class="node-input"></el-input>
          </el-form-item>
          <el-divider direction="vertical"></el-divider>
          <el-form-item label="" prop="sqlHostAndIp">
            <el-input
              v-model="item.sqlHostAndIp"
              placeholder="请输入"
              class="node-input"
            ></el-input>
          </el-form-item>
          <el-divider direction="vertical"></el-divider>
          <el-form-item label="" prop="sqlPort">
            <el-input
              v-model.number="item.sqlPort"
              placeholder="请输入"
              class="node-input narrow"
            ></el-input>
          </el-form-item>
          <el-divider direction="vertical"></el-divider>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeploySetting',
  props: {
    enableContractSql: {
      type: Boolean,
      default: true
    },
    displayNodeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let validateAddr = (rule, value, callback) => {
      let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
      if (value === '') {
        callback(new Error('请输入节点IP地址'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的节点IP地址'))
      } else {
        callback()
      }
    }
    let validatePort = (rule, value, callback) => {
      let reg = /^\d+$/
      if (value === '') {
        callback(new Error('请输入端口号'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的端口'))
      } else {
        callback()
      }
    }
    let validateContractSqlAddr = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入节点IP地址'))
      } else if (!this.testIP(value)) {
        callback(new Error('请输入正确的节点IP地址'))
      } else {
        callback()
      }
    }
    return {
      deployMethod: 0,
      supportContractSql: 0,
      nodeList: [],
      editRules: {
        NodeIp: [{ required: true, validator: validateAddr }],
        NodeP2pPort: [{ required: true, validator: validatePort }],
        NodeRpcPort: [{ required: true, validator: validatePort }]
      },
      contractSqlEditRules: {
        sqlUserName: [{ required: true, message: '请输入用户名', trigger: ['blur', 'change'] }],
        sqlPassword: [{ required: true, message: '请输入密码', trigger: ['blur', 'change'] }],
        sqlHostAndIp: [{ required: true, validator: validateContractSqlAddr }],
        sqlPort: [{ required: true, validator: validatePort }]
      }
    }
  },
  watch: {
    displayNodeList: function(val) {
      if (this.$utils.isEmpty(val)) {
        this.nodeList = []
      } else {
        this.handleData(val)
      }
    }
  },
  methods: {
    handleData(data) {
      if (this.$utils.isEmpty(this.nodeList)) {
        let addedMap = {}
        for (let i = 0; i < data.length; i++) {
          if (!addedMap[data[i]]) {
            let param = {
              NodeName: data[i],
              NodeRpcPort: null,
              NodeP2pPort: null,
              NodeIp: '',
              sqlUserName: null,
              sqlPassword: null,
              sqlHostAndIp: null,
              sqlPort: null,
              SqlDbDsn: null
            }
            this.nodeList.push(param)
          }
        }
      } else {
        let type = this.nodeList.length > data.length ? 'delete' : 'add'
        // 比较数据
        if (type === 'add') {
          let nodes = this.nodeList.map(item => {
            return item.NodeName
          })
          data.forEach(ele => {
            if (!nodes.includes(ele)) {
              let param = {
                NodeName: ele,
                NodeRpcPort: null,
                NodeP2pPort: null,
                NodeIp: '',
                sqlUserName: null,
                sqlPassword: null,
                sqlHostAndIp: null,
                sqlPort: null,
                SqlDbDsn: null
              }
              this.nodeList.push(param)
            }
          })
        } else {
          let item = this.nodeList.filter((ele, i) => {
            if (!data.includes(ele['NodeName'])) {
              return ele
            }
          })
          let index = this.nodeList.findIndex(elem => elem['NodeName'] === item[0]['NodeName'])
          this.nodeList.splice(index, 1)
        }
      }
    },
    clearData() {
      this.deployMethod = 0
      this.nodeList = []
    },
    // 父组件获取数据
    getSingle() {
      return parseInt(this.deployMethod)
    },
    getData() {
      if (this.deployMethod === 0) {
        if (this.$utils.isEmpty(this.nodeList[0]['NodeIp'])) {
          this.$message.warning('请完善节点部署配置信息！')
          this.$emit('change:disable')
          return false
        } else {
          let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
          if (!reg.test(this.nodeList[0]['NodeIp'])) {
            this.$message.warning('请输入正确的节点IP！')
            this.$emit('change:disable')
            return false
          }
        }
        let hasEmptyItem = this.nodeList.filter((ele, i) => {
          let condition =
            !this.$utils.isEmpty(ele['NodeRpcPort']) && !this.$utils.isEmpty(ele['NodeP2pPort'])
          if (!condition) {
            return ele
          }
        })
        if (!this.$utils.isEmpty(hasEmptyItem)) {
          this.$message.warning('请完善节点部署配置信息！')
          this.$emit('change:disable')
          return false
        } else {
          let validArr = this.nodeList.filter(ele => {
            let regs = /^\d+$/
            if (!regs.test(ele['NodeP2pPort']) || !regs.test(ele['NodeRpcPort'])) return ele
          })
          if (validArr.length > 0) {
            this.$message.warning('请输入正确的端口！')
            this.$emit('change:disable')
            return false
          } else {
            this.nodeList.map((ele, i) => {
              if (i === 0 && this.$utils.isEmpty(ele['NodeIp'])) {
                this.$message.warning('请完善节点部署配置信息！')
                this.$emit('change:disable')
                return false
              } else {
                ele['NodeIp'] = this.nodeList[0]['NodeIp']
              }
            })
            if (this.verifyContractSql(this.nodeList)) {
              return this.nodeList
            }
          }
        }
      } else {
        // 多机部署
        let hasEmptyItem = this.nodeList.filter((ele, i) => {
          let condition =
            this.$utils.isEmpty(ele['NodeRpcPort']) ||
            this.$utils.isEmpty(ele['NodeP2pPort']) ||
            this.$utils.isEmpty(ele['NodeIp'])
          if (condition) {
            return ele
          }
        })
        if (!this.$utils.isEmpty(hasEmptyItem)) {
          this.$message.warning('请完善节点部署配置信息！')
          this.$emit('change:disable')
          return false
        } else {
          let validArr = this.nodeList.filter(ele => {
            let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
            let reg1 = /^\d+$/
            if (
              !reg.test(ele['NodeIp']) ||
              !reg1.test(ele['NodeP2pPort']) ||
              !reg1.test(ele['NodeRpcPort'])
            )
              return ele
          })
          if (validArr.length > 0) {
            this.$message.warning('请输入正确的节点IP或端口！')
            this.$emit('change:disable')
            return false
          } else {
            if (this.verifyContractSql(this.nodeList)) {
              return this.nodeList
            }
          }
        }
      }
    },
    verifyContractSql(nodeList) {
      let result = true
      if (this.supportContractSql && this.enableContractSql) {
        result = false
        let errMsg = null
        for (let i = 0; i < nodeList.length; i++) {
          let item = nodeList[i]
          if (this.$utils.isEmpty(item.sqlUserName)) {
            errMsg = `请输入${item.NodeName}的数据库用户名!`
            break
          }
          if (this.$utils.isEmpty(item.sqlPassword)) {
            errMsg = `请输入${item.NodeName}的数据库密码!`
            break
          }
          if (this.$utils.isEmpty(item.sqlHostAndIp)) {
            errMsg = `请输入${item.NodeName}的数据库Host/IP!`
            break
          }
          if (!this.testIP(item.sqlHostAndIp)) {
            errMsg = `${item.NodeName}的数据库Host/IP格式有误!`
            break
          }
          if (this.$utils.isEmpty(item.sqlPort)) {
            errMsg = `请输入${item.NodeName}的数据库端口!`
            break
          }
          if (!this.testPort(item.sqlPort)) {
            errMsg = `请输入正确的${item.NodeName}的数据库端口!`
            break
          }
          item.SqlDbDsn = `${item.sqlUserName}:${item.sqlPassword}@tcp(${item.sqlHostAndIp}:${item.sqlPort})/`
        }

        if (errMsg) {
          this.$message.warning(errMsg)
          this.$emit('change:disable')
        } else {
          result = true
        }
      }
      return result
    },
    testIP(ip) {
      let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
      let hostReg = /^[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(?:\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
      let result = hostReg.test(ip)
      if (result) {
        let ipParts = ip.split('.')
        if (ipParts.every(e => this.$utils.isNumber(Number(e)))) {
          result = reg.test(ip)
        }
      }
      return result
    },
    testPort(port) {
      let regs = /^\d+$/
      return regs.test(port)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'deploy-setting',
  (
    --deploy-setting-labels-color: #fff,
    --deploy-setting-header-bg-color: #303c65,
    --deploy-setting-header-color: #8babba,
    --deploy-setting-border-color: #33496e,
    --deploy-setting-content-color: #fff
  ),
  (
    --deploy-setting-labels-color: #192227,
    --deploy-setting-header-bg-color: #f4f4f5,
    --deploy-setting-header-color: #192227,
    --deploy-setting-border-color: #ebebeb,
    --deploy-setting-content-color: #192227
  )
);
.deploy-setting {
  @include adaptation(
    (
      --deploy-setting-type-def-wrap-margin-bottom: 8px,
      --deploy-setting-type-def-margin-left: 64px,
      --deploy-setting-type-def-alert-margin-bottom: 8px,
      --deploy-setting-type-def-alert-width: 800px,
      --deploy-setting-font-size: 12px,
      --deploy-setting-labels-height: 17px,
      --deploy-setting-labels-margin-bottom: 8px,
      --deploy-setting-border-width: 1px,
      --deploy-setting-header-cell-padding: 8px,
      --deploy-setting-header-cell-width: 180px,
      --deploy-setting-header-cell-narrow-width: 100px,
      --deploy-setting-header-node-col-width: 120px,
      --deploy-setting-content-node-col-width: 120px,
      --deploy-setting-content-node-col-padding: 10px 16px,
      --deploy-setting-content-form-item-margin-top: 8px,
      --deploy-setting-content-last-vertical-divider-margin: 0 0 0 1px,
      --deploy-setting-content-input-width: 179px,
      --deploy-setting-content-input-narrow-width: 99px
    )
  );

  .type-def-wrap {
    display: flex;
    margin-bottom: var(--deploy-setting-type-def-wrap-margin-bottom);

    .type-def {
      font-size: var(--deploy-setting-font-size);

      &:not(:first-child) {
        margin-left: var(--deploy-setting-type-def-margin-left);
      }

      .labels {
        height: var(--deploy-setting-labels-height);
        line-height: var(--deploy-setting-labels-height);
        color: var(--deploy-setting-labels-color);
        margin-bottom: var(--deploy-setting-labels-margin-bottom);
        display: flex;
      }
    }
  }

  .type-def-alert {
    margin-bottom: var(--deploy-setting-type-def-alert-margin-bottom);
    width: var(--deploy-setting-type-def-alert-width);
  }

  .input-wrap {
    .input-header {
      display: flex;
      color: var(--deploy-setting-header-color);

      .header-section {
        background-color: var(--deploy-setting-header-bg-color);
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-top: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);
        border-right: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);
        border-bottom: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);

        .header-line {
          display: flex;
          width: 100%;
          justify-content: center;
          text-align: center;

          .cell {
            padding: var(--deploy-setting-header-cell-padding);
            display: inline-block;
            width: var(--deploy-setting-header-cell-width);
            border-right: var(--deploy-setting-border-width) solid
              var(--deploy-setting-border-color);

            &.narrow {
              width: var(--deploy-setting-header-cell-narrow-width);
            }

            &:last-child {
              border-right: none;
            }
          }

          &:not(:first-child) {
            .cell {
              border-top: var(--deploy-setting-border-width) solid
                var(--deploy-setting-border-color);
            }
          }
        }

        &:first-child {
          border-left: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);
        }

        &.node-header {
          width: var(--deploy-setting-header-node-col-width);
        }
      }
    }

    .input-item {
      display: flex;

      .labels {
        color: var(--deploy-setting-content-color);
        width: var(--deploy-setting-content-node-col-width);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--deploy-setting-content-node-col-padding);
        border-left: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);
        border-right: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);
        border-bottom: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);

        span {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .el-form {
        border-bottom: var(--deploy-setting-border-width) solid var(--deploy-setting-border-color);
      }

      .el-form-item {
        margin-right: 0;
        position: relative;
        margin-top: var(--deploy-setting-content-form-item-margin-top);
      }
      .el-divider.el-divider--vertical {
        margin: 0;
        height: 100%;

        &:last-child {
          margin: var(--deploy-setting-content-last-vertical-divider-margin);
        }
      }

      .node-input {
        width: var(--deploy-setting-content-input-width);

        &.narrow {
          width: var(--deploy-setting-content-input-narrow-width);
        }
      }
    }
  }

}
</style>
